import "./../../blocks/blocks.js";
import "./internal.js";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";

import "@dotlottie/player-component";
import * as gsap from "gsap";

import ZipCodeVerify from "./lib/zipcode-verify";

import ContestLinks from "./lib/contest-links";

import "@shoelace-style/shoelace/dist/components/icon/icon.js";
import { registerIconLibrary } from "@shoelace-style/shoelace/dist/utilities/icon-library.js";

registerIconLibrary("default", {
	resolver: (name) => `/wp-content/themes/posturepress3/dist/images/icons/${name}.svg`,
});
document.addEventListener("DOMContentLoaded", function () {
	document.querySelector("body").setAttribute("data-s-loaded", "");
	//new BetterMenu();
	//new BetterModal();

	new ZipCodeVerify();
	new ContestLinks();
});
